import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const StopIcon = ({
  color = 'black80',
  width = 22,
  marginLeft,
  marginRight,
  containerSize,
  title,
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM15.152 17.4858C13.954 18.2543 12.529 18.7 11 18.7C6.74741 18.7 3.3 15.2526 3.3 11C3.3 9.47096 3.74568 8.04602 4.51421 6.84799L15.152 17.4858ZM17.4855 15.1524L6.8476 4.51447C8.04571 3.74577 9.4708 3.3 11 3.3C15.2526 3.3 18.7 6.74741 18.7 11C18.7 12.5292 18.2542 13.9543 17.4855 15.1524Z"
        fill={getSemanticTextColor(color)}
      />
    </svg>
  </DefaultIconWrapper>
);
